// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1b4D_","head":"ProcedureTableInfo_head__2x6rV"};